module.exports = require('./helpers/bundle-url').getBundleURL('kuLgW') + "workers.fc9ae46e.js";